import { getEnv, Instance, types } from 'mobx-state-tree';
import Axios, { AxiosResponse } from 'axios';
import type { IResponse } from '@yakoffice/publisher-types';
import { flow } from 'mobx';

export const ApiRequest = types.model(
  'ApiRequest',
  {})
  .actions(self => ({
    createHeaderOption: flow(function* () {
      const token = yield getEnv(self).bearerTokenProvider.getToken();
      return {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      };
    }),
    createHeaderOptionForImages: flow(function* () {
      const token = yield getEnv(self).bearerTokenProvider.getToken();
      return {
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + token
          // "Content-Type": "multipart/form-data",
          // "mimeType": "multipart/form-data",
          // 'Content-Type': 'multipart/form-data',
          // 'boundary': "14737809831466499882746641449"
        }
      };
    })
  }))
  .actions(self => ({
    get: flow(function* <T>(url: string) {
      const res = yield Axios.get<IResponse<T>>(url, yield self.createHeaderOption());
      return (res as unknown as AxiosResponse<IResponse<T>>).data.data;
    }),
    post: flow(function* <T>(url: string, data: unknown) {
      const res = yield Axios.post(url, data, yield self.createHeaderOption());
      return (res as unknown as AxiosResponse<IResponse<T>>).data.data;
    }),
    postImage: flow(function* <T>(url: string, data: unknown) {
      const res = yield Axios.post(url, data, yield self.createHeaderOptionForImages());
      return (res as unknown as AxiosResponse<IResponse<T>>).data;
    }),
    put: flow(function* <T>(url: string, data: unknown) {
      const res = yield Axios.put(url, data, yield self.createHeaderOption());
      return (res as unknown as AxiosResponse<IResponse<T>>).data.data;
    }),
    patch: flow(function* <T>(url: string, data: unknown) {
      const res = yield Axios.patch(url, data, yield self.createHeaderOption());
      return (res as unknown as AxiosResponse<IResponse<T>>).data.data;
    }),
    delete: flow(function* (url: string) {
      yield Axios.delete(url, yield self.createHeaderOption());
    })
  }));


export interface IHeaderProvider extends Instance<typeof ApiRequest> {
}
